export default "__VITE_PUBLIC_ASSET__c335b2b9__"